module.exports = __webpack_public_path__ + "img/bmat_logo_magenta_original.c5f59840.jpg";